<script setup>
</script>
<template>
    <div class="loader">
        <img width="100" height="100" src="@/assets/img/icons/loader.svg" alt="изображение" />
    </div>
</template>
<style lang='scss' scoped>
.loader {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    inset: 0;
    background-color: var(--fill-default-1);
    opacity: .9;
    z-index: 1;
    img {
        width: 10rem;
        height: 10rem;
        animation: loader 4s linear infinite;
    }
}
@keyframes loader {
    0% {transform: rotate(0);}
    100% {transform: rotate(360deg);}
}
</style>